export default __webpack_public_path__ + "static/media/creative.dc711c01.png";